import { gql } from '__generated__';

export const TeamFieldsFragment = gql(`
  fragment TeamFields on Team {
    id
    title
    access_code
    participants_count
    captain {
      id
    }
    team_type {
      id
      title
      join_policy
    }
    members {
      id
      sequence
      ticket {
        id
        title
        allow_individuals
      }
      locked
      full_name
      status
    }
  }
`);

export default gql(`
  query GetTeamDetails($id: ID!) {
    team(id: $id) {
      ...TeamFields
    }
  }
`);
